import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsprogress-bar',
	templateUrl:'./BSProgressBarPluginCompPage.html',
	styles: [],
	styleUrls:['./BSProgressBarPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSProgressBarPluginCompPage
{
	mdContent_853 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.progressbar.BSProgressBar;
\`\`\``;
	mdContent_854 = `\`\`\`java
BSProgressBar()
\`\`\``;
	mdContent_855 = `\`\`\`java
BSProgressBar&lt;?&gt; bar = new BSProgressBar&lt;&gt;();
bar.setValue(75);
bar.setStriped(true);
bar.setAnimated(true);
bar.setType(BSColourTypes.Success);
\`\`\``;
}
